module.exports = __webpack_public_path__ + "static/media/IMG_0800.abe11315.jpg";